import { render, staticRenderFns } from "./VFilterLegacy.vue?vue&type=template&id=091970cb"
import script from "./VFilterLegacy.vue?vue&type=script&lang=js"
export * from "./VFilterLegacy.vue?vue&type=script&lang=js"
import style0 from "./VFilterLegacy.vue?vue&type=style&index=0&id=091970cb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports